import {
  AUTOCALL_GET,
  AUTOCALL_UPDATE,
  AUTOCALL_CUSTOM,
  AUTOCALL_REPORT,
  AUTOCALL_GET_RUN_TASKS,
  AUTOCALL_GET_RUN_STATS,
  AUTOCALL_GET_RUN,
  AUTOCALL_UPDATE_RUN_STATUS,
  AUTOCALL_UPDATE_TASK_RUN_STATUS,
  AUTOCALL_RUN_ARCHIVE,
  AUTOCALL_EDIT_RUN
} from '../types/actions.types';
import { SET_ALL } from '../types/mutations.types';
import AutoCall from '../../api/methods/AutoCall';

const state = {
  pagination: {}
};

const getters = {
};

const actions = {

  async [AUTOCALL_GET] (vuex, { context, params = {} }) {
    try {
      const payload = await AutoCall.getAutoCall(params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_GET_RUN_TASKS] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.getAutoCallRunIdTasks(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_GET_RUN_STATS] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.getAutoCallRunIdStats(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_GET_RUN] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.getAutoCallRunId(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_EDIT_RUN] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.editAutoCallRun(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_UPDATE_RUN_STATUS] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.updateAutoCallRunId(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_RUN_ARCHIVE] (vuex, { context, id }) {
    try {
      const payload = await AutoCall.archiveAutoCallRunId(id);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_UPDATE_TASK_RUN_STATUS] (vuex, { context, id, params = {} }) {
    try {
      const payload = await AutoCall.updateTaskAutoCall(id, params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_UPDATE] (vuex, { context, params = {} }) {
    try {
      const { payload } = await AutoCall.autoCall(params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_CUSTOM] (vuex, { context, params = {} }) {
    try {
      const { payload } = await AutoCall.autoCallCustom(params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [AUTOCALL_REPORT] (vuex, { context, params = {} }) {
    try {
      const payload = await AutoCall.autoCallReport(params);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }
};

const mutations = {
  [SET_ALL] (state, { data, key }) {
    state[key] = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
